<p-popover appPopoverArrow #op appendTo="body"> Average margin </p-popover>

<div
  *ngxPermissionsOnly="role.readOnly"
  class="quote-footer quote-{{ quote.getStatus() }}"
>
  @if (
    quote.getStatus() !== quoteStatus.draft &&
    quote.getStatus() !== quoteStatus.pending
  ) {
    <div>
      @if (quote.getFileName()) {
        <button pButton [text]="true" size="small" (click)="downloadQuote()">
          <i class="pi pi-download"></i> Download PDF
        </button>
      }
    </div>
  }
</div>

<div
  *ngxPermissionsExcept="role.readOnly"
  class="quote-footer quote-{{ quote.getStatus() }}"
>
  @if (
    quote.getStatus() === quoteStatus.draft ||
    quote.getStatus() === quoteStatus.error
  ) {
    <div class="quote-footer-actions">
      <div class="average-margin-wrapper">
        @if (isAvarageMarginAvailable()) {
          <span
            class="average-margin d-none d-lg-inline-block"
            [class.average-margin--error]="getAverageMargin() < 0"
          >
            Average margin:
            <span>
              {{ getAverageMarginText() }}
              @if (getAverageMarginPercent()) {
                ({{ getAverageMarginPercent() * 100 | currency }}%)
              }
            </span>
          </span>
        }
        @if (isAvarageMarginAvailable()) {
          <span
            class="average-margin d-inline-block d-lg-none"
            [class.average-margin--error]="getAverageMargin() < 0"
          >
            <span (click)="op.toggle($event)" aria-hidden="true">
              {{ getAverageMarginText() }}
            </span>
          </span>
        }
      </div>
      <div class="footer-actions">
        <div class="footer-actions-start">
          <button
            pButton
            [text]="true"
            data-cy="quote-save-and-close"
            size="small"
            (click)="emitClose()"
          >
            <i class="pi pi-save"></i> Save
          </button>
          @if (quote.getSource() !== quoteSource.online) {
            <button
              pButton
              [text]="true"
              severity="danger"
              data-cy="quote-delete"
              size="small"
              [disabled]="loading"
              (click)="deleteQuote(quote)"
            >
              <i class="pi pi-trash"></i> Delete
            </button>
          }
        </div>
        <div class="footer-actions-end">
          <span class="footer-divider" aria-hidden="true"></span>
          @if (activeTab() !== tabs.email) {
            <button
              pButton
              data-cy="quote-next"
              id="e-quote-next"
              [disabled]="!isNextTabPossible()"
              (click)="emitNextTab()"
            >
              Next <i class="pi pi-angle-right"></i>
            </button>
          } @else {
            <button
              pButton
              data-cy="quote-email-send"
              id="e-quote-send"
              [disabled]="
                !!loading || !quote.isSendable() || !isMailFormValid()
              "
              (click)="sendQuote(quote)"
            >
              Send
            </button>
          }
        </div>
      </div>
    </div>
  }
  @if (
    quote.getStatus() !== quoteStatus.draft &&
    quote.getStatus() !== quoteStatus.pending
  ) {
    <div class="quote-footer-actions">
      <div class="average-margin-wrapper">
        <span
          class="average-margin d-none d-lg-inline-block"
          [class.average-margin--error]="getAverageMargin() < 0"
        >
          Average margin:
          <span>
            {{ getAverageMarginText() }}
            @if (getAverageMarginPercent()) {
              ({{ getAverageMarginPercent() * 100 | currency }}%)
            }
          </span>
        </span>
        <span
          class="average-margin d-inline-block d-lg-none"
          [class.average-margin--error]="getAverageMargin() < 0"
        >
          <span (click)="op.toggle($event)" aria-hidden="true">
            {{ getAverageMarginText() }}
          </span>
        </span>
      </div>
      <div class="footer-actions">
        <div class="footer-actions-start">
          <button
            pButton
            [text]="true"
            data-cy="quote-replicate"
            size="small"
            [disabled]="loading"
            (click)="replicateQuote()"
          >
            <i class="pi pi-copy"></i> Replicate
          </button>
          @if (quote.getFileName()) {
            <button
              pButton
              [text]="true"
              data-cy="quote-download"
              size="small"
              (click)="downloadQuote()"
            >
              <i class="pi pi-download"></i> Download PDF
            </button>
          }
          <button
            pButton
            *ngxPermissionsOnly="role.organizationAdmin"
            [text]="true"
            severity="danger"
            data-cy="quote-delete"
            size="small"
            [disabled]="loading"
            (click)="deleteQuote(quote)"
          >
            <i class="pi pi-trash"></i> Delete
          </button>
        </div>
        <div class="footer-actions-end">
          <span class="footer-divider" aria-hidden="true"></span>
          @if (
            quote.getStatus() !== quoteStatus.declined &&
            quote.getStatus() !== quoteStatus.negotiated
          ) {
            <button
              pButton
              [outlined]="true"
              data-cy="quote-declined"
              [disabled]="loading"
              (click)="declineFormVisible = true"
            >
              <i class="pi pi-times"></i> Decline
            </button>
          }
          @if (
            quote.getStatus() === quoteStatus.declined &&
            quote.getStatus() !== quoteStatus.negotiated
          ) {
            <button
              pButton
              [outlined]="true"
              data-cy="quote-declined"
              [disabled]="loading"
              (click)="undeclineQuote(quote)"
            >
              <i class="pi pi-undo"></i> Undecline
            </button>
          }
          <button
            pButton
            severity="success"
            data-cy="quote-negotiate"
            [disabled]="loading"
            (click)="negotiateQuote()"
          >
            <i class="pi pi-arrow-right-arrow-left"></i> Negotiate
          </button>
          @if (quote.getStatus() !== quoteStatus.accepted) {
            <button
              pButton
              data-cy="quote-accepted"
              [disabled]="loading"
              (click)="acceptQuote(quote)"
            >
              <i class="pi pi-check"></i> Accept
            </button>
          }
          @if (
            quote.getStatus() === quoteStatus.accepted &&
            quote.getStatus() !== quoteStatus.negotiated
          ) {
            <button
              pButton
              [outlined]="true"
              data-cy="quote-unaccepted"
              [disabled]="loading"
              (click)="unacceptQuote(quote)"
            >
              <i class="pi pi-times"></i> Unaccept
            </button>
          }
        </div>
      </div>
    </div>
  }
</div>

@if (declineFormVisible) {
  <app-quote-decline-form
    (closeView)="declineFormVisible = false"
    (declineQuote)="declineQuote($event); declineFormVisible = false"
  >
  </app-quote-decline-form>
}
